module.exports = __webpack_public_path__ + "img/cs_logo-w160_grey.7334f37d.png";